<template>
  <div>
    <slot :open="open" :refine="refine" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      open: false
    };
  },
  methods: {
    refine(state) {
      this.open = state;
    }
  }
};
</script>